import { render } from "./CInputText.vue?vue&type=template&id=1da43db8"
import script from "./CInputText.vue?vue&type=script&lang=js"
export * from "./CInputText.vue?vue&type=script&lang=js"

import exportComponent from "/home/ydf/remit/shared/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__